export declare namespace PresetTextTokenSections {
	interface Text {
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
		color: string;
	}
}

export type PresetTextTokens = {
	text: PresetTextTokenSections.Text;
};

export const text: PresetTextTokenSections.Text = {
	fontSize: '16px',
	fontWeight: '400',
	lineHeight: '26px',
	color: '{surface.950}',
};

/** Read-only server-generated preset text shown above the conclusion-step textareas. */
export default {
	text,
} satisfies PresetTextTokens;
